module.exports = __webpack_public_path__ + "static/media/pizza3.8631251b.png";